import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import auth from '../../services/authService';
import { setDocTitle } from '../../utils/utilities';
import PageBar from '../../components/PageBar';
import NoContent from '../../components/common/NoContent';
import { getTeam } from '../../services/teamService';
import TeamMembers from './components/TeamMembers';
import TeamInvitation from './components/TeamInvitation';
import TeamFaces from './components/TeamFaces';
import Fireworks from '../../components/common/Fireworks';

import './Team.scss';

const MyTeam = () => {
  const { t } = useTranslation();
  const [team, setTeam] = useState({});
  const [user, setUser] = useState({});
  const [inviteLink, setInviteLink] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setDocTitle(t('team.title'));
  }, [t]);

  useEffect(() => {
    // Get current user
    const currentUser = auth.getCurrentUser();

    setUser(currentUser);

    // Get user's team
    const fetchTeam = async () => {
      if (currentUser.teamId) {
        try {
          const { data: team } = await getTeam(currentUser.teamId);
          setTeam(team);
          setInviteLink(`https://${window.location.host}/signup/${team._id}`);
        } catch (error) {
          toast.error(i18n.t('team.loadFailed'));
        }
      }
      setLoading(false);
    };
    fetchTeam();
  }, []);

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      toast.error(t('team.copyFailed'));
      return false;
    }
  };

  const handleRemoveUserFromTeam = (userId) => {
    setTeam((prevTeam) => ({
      ...prevTeam,
      users: prevTeam.users.filter((user) => user._id !== userId),
    }));
  };

  return (
    <div className="Team mg-container">
      <PageBar back={{ label: t('common.back'), icon: true }} title={t('team.title')} />
      {loading ? (
        <NoContent loading={loading} />
      ) : (
        <>
          <Fireworks />
          <div className="content">
            <div className="header">
              <div className="card">
                <TeamFaces users={team.users} />
                <h2 className="name">{team.name}</h2>
                <TeamMembers team={team} currentUser={user} onRemoveUser={handleRemoveUserFromTeam} />
              </div>
            </div>
            {user && user.isAdmin && (
              <TeamInvitation team={team} inviteLink={inviteLink} teamId={team._id} onCopyText={copyToClipboard} />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default MyTeam;
